import { render, staticRenderFns } from "./DetailJobRequest.vue?vue&type=template&id=6529ea16&scoped=true&"
import script from "./DetailJobRequest.vue?vue&type=script&lang=js&"
export * from "./DetailJobRequest.vue?vue&type=script&lang=js&"
import style0 from "./DetailJobRequest.vue?vue&type=style&index=0&id=6529ea16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6529ea16",
  null
  
)

export default component.exports